import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=9c4276ee&scoped=true&"
import script from "./Pass.vue?vue&type=script&lang=js&"
export * from "./Pass.vue?vue&type=script&lang=js&"
import style0 from "./Pass.vue?vue&type=style&index=0&id=9c4276ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4276ee",
  null
  
)

export default component.exports